module.exports = __webpack_public_path__ + "img/candy-cane.fcf41e04.svg";